<template>
  <div class="px-3 py-2">
    <div class="flex items-center justify-between mt-3">
      <div class="flex items-center gap-2">
        <h2 class="text-base font-bold">{{ t(`story.style.demo`) }}</h2>
        <i class="iconfont icon-info p-1" @click="clickInfo" />
      </div>

      <div>
        <button
          class="btn btn-xs rounded mr-2"
          v-if="store.form.exampleText"
          @click="store.resetOneForm('exampleText')"
        >
          {{ $t("Buttons.clear") }}
        </button>
        <button class="btn btn-xs rounded mr-2" @click="clickSelect">
          {{ t(`story.style.select`) }}
        </button>
        <!-- <button
          class="btn  btn-xs rounded"
          @click="store.openGenerateModal('exampleText')"
        >
          {{ t(`story.auto`) }}
        </button> -->
      </div>
    </div>
    <div class="text-xs"></div>
    <VanField
      v-model="store.form.exampleText"
      rows="1"
      :autosize="{ minHeight: 430 }"
      type="textarea"
      class="mt-2.5 text-[#ABABAB]"
    />
  </div>
</template>

<script setup lang="ts">
import { useStory } from "@/stores/story";
import { useStoryBook } from "@/stores/story-book";
import { showToast } from "vant";
import { useI18n } from "vue-i18n";

const { t } = useI18n();
const store = useStoryBook();
const storyStore = useStory();

const clickInfo = () => {
  showToast({
    message: t("Message.textGeneratedToast"),
    position: "top",
    duration: 5000,
    closeOnClick: true,
  });
};

const clickSelect = async () => {
  store.edit.selectChapterType = 0;
  store.edit.showSelectChapter = true;
  store.edit.selectChapterId = store.edit.styleChapterId;
  store.edit.chapterLoading = true;
  store.edit.isShowStoryBook = true;
  try {
    await storyStore.getEditStoryList();
  } catch (e) {}
  store.edit.chapterLoading = false;
};
</script>
